(function () {
  'use strict';

  var AGE_GATE_KEY = 'arrebol_age_verified';

  var gate = document.getElementById('arrebol-age-gate');

  if (!gate) {
    return;
  }

  var acceptButton = document.getElementById('arrebol-age-gate-accept');
  var rejectButton = document.getElementById('arrebol-age-gate-reject');


  /* =========================================================
     VERIFICACIÓN DE SESIÓN
     ========================================================= */

  function hasVerifiedAge() {
    try {
      return sessionStorage.getItem(AGE_GATE_KEY) === 'true';
    } catch (error) {
      return false;
    }
  }


  function saveVerification() {
    try {
      sessionStorage.setItem(AGE_GATE_KEY, 'true');
    } catch (error) {}
  }


  /* =========================================================
     BLOQUEAR PÁGINA
     ========================================================= */

  function lockPage() {
    document.documentElement.classList.add(
      'arrebol-age-gate-active'
    );

    document.body.classList.add(
      'arrebol-age-gate-active'
    );

    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }


  /* =========================================================
     DESBLOQUEAR PÁGINA
     ========================================================= */

  function unlockPage() {
    document.documentElement.classList.remove(
      'arrebol-age-gate-active'
    );

    document.body.classList.remove(
      'arrebol-age-gate-active'
    );

    document.documentElement.style.removeProperty('overflow');
    document.body.style.removeProperty('overflow');

    gate.hidden = true;

    gate.setAttribute(
      'aria-hidden',
      'true'
    );
  }


  /* =========================================================
     SI YA FUE VERIFICADO DURANTE ESTA SESIÓN
     ========================================================= */

  if (hasVerifiedAge()) {
    unlockPage();
    return;
  }


  /* =========================================================
     MOSTRAR AGE GATE
     ========================================================= */

  gate.hidden = false;

  gate.removeAttribute('aria-hidden');

  lockPage();


  /* =========================================================
     SI ENTRAR / ENTER
     ========================================================= */

  if (acceptButton) {

    acceptButton.addEventListener(
      'click',
      function () {

        saveVerification();

        unlockPage();

        /*
         * Si el usuario no está en la Home,
         * lo llevamos a la página principal.
         */

        var homeUrl = '/';

        if (window.location.pathname !== '/') {
          window.location.href = homeUrl;
        }

      }
    );

  }


  /* =========================================================
     NO
     ========================================================= */

  if (rejectButton) {

    rejectButton.addEventListener(
      'click',
      function () {

        /*
         * No se guarda ninguna autorización.
         */

        window.location.href =
          'https://www.google.com/';

      }
    );

  }


  /* =========================================================
     SHOPIFY THEME EDITOR
     ========================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      if (
        event.detail &&
        event.detail.sectionId
      ) {

        gate.hidden = false;

        gate.removeAttribute(
          'aria-hidden'
        );

        lockPage();
      }

    }
  );

})();